import styled from 'styled-components'

export const CardContainer = styled.div`
  display: table-cell;
  text-align: -webkit-center;
  width: 100%;
`

export const Container = styled.div`
  box-shadow: 0px 8px 16px #eaeaea;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  display: flex;
  justify-content: center;
`

export const NameInfo = styled.p`
  margin-top: 30px;
  color: var(--black);
  line-height: 40px;
  font-family: 'Noto Sans Thai';
  font-size: clamp(20px, 2.5vw, 24px);
`

export const CardImages = styled.div`
  width: inherit;
  height: inherit;
  border-radius: 20px;

  img {
    width: inherit;
    height: inherit;
    border-radius: 20px;
    object-fit: cover;
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transition: 0.3s ease-in-out;
    transition: 0.3s ease-in-out;
  }

  &:hover img {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
`
